const escapeCsv = (value = "") => `"${String(value).replace(/"/g, '""')}"`;

const rowsToCsv = (headers = [], rows = []) => {
  const head = headers.map(escapeCsv).join(",");
  const body = rows
    .map((row) => headers.map((header) => escapeCsv(row?.[header] ?? "")).join(","))
    .join("\n");

  return [head, body].filter(Boolean).join("\n");
};

const normalizeSection = (filename, headers = [], rows = []) => {
  if (!rows.length) return null;

  return {
    filename,
    content: rowsToCsv(headers, rows),
  };
};

export const buildCsvSections = ({ model, t }) => {
  const language = model.language;
  const fieldLabel = t("reports.field", language === "en" ? "Field" : "الحقل");
  const valueLabel = t("reports.value", language === "en" ? "Value" : "القيمة");
  const itemLabel = t("reports.item", language === "en" ? "Item" : "البند");
  const metricLabel = t("reports.metric", language === "en" ? "Metric" : "النسبة");
  const changeLabel = t("reports.change", language === "en" ? "Change" : "التغير");
  const textLabel = t("reports.text", language === "en" ? "Text" : "النص");

  if (model.aiServiceFailure) {
    return [
      normalizeSection("ai-analysis-status", [fieldLabel, valueLabel], [
        {
          [fieldLabel]: t("reports.aiAnalysisFailed", language === "en" ? "AI analysis failed" : "فشل التحليل الذكي"),
          [valueLabel]: model.userFacingAiError,
        },
      ]),
    ].filter(Boolean);
  }

  return [
    normalizeSection(
      "report-meta",
      [fieldLabel, valueLabel],
      model.reportMeta.map((item) => ({ [fieldLabel]: item.label, [valueLabel]: item.value }))
    ),
    normalizeSection(
      "basic-report-data",
      [fieldLabel, valueLabel],
      model.basicReportData.map((item) => ({ [fieldLabel]: item.label, [valueLabel]: item.value }))
    ),
    normalizeSection(
      "numerical-results",
      [itemLabel, metricLabel, valueLabel, changeLabel],
      (model.numericalResults?.rows || []).map((row) => ({
        [itemLabel]: row.item,
        [metricLabel]: row.metric,
        [valueLabel]: row.value,
        [changeLabel]: row.change,
      }))
    ),
    normalizeSection(
      "analysis",
      [fieldLabel, textLabel],
      model.analysis.map((item, index) => ({ [fieldLabel]: index + 1, [textLabel]: item }))
    ),
    normalizeSection(
      "recommendations-alerts",
      [textLabel],
      model.recommendationsAndAlerts.map((item) => ({ [textLabel]: item }))
    ),
  ].filter(Boolean);
};
